export default __webpack_public_path__ + "a8332dcc000bf0734cbc4338d0317643.svg";